import Card from '../components/card/Card';
import P from '../components/texts/p/P';

export interface CommissionData {
  id: number;
  name: string;
  line_type: string;
  commission_type_name: string;
  amount: number;
}

export function getCommissionColumns() {
  return [
    {
      name: 'Nombre',
      selector: (row: CommissionData) => row.name,
      cell: (row: CommissionData) => (
        <Card>
          <P type='3' variant='neutral'>
            {row.name}
          </P>
        </Card>
      ),
      minWidth: '150px',
      grow: 1,
    },
    {
      name: 'Línea',
      selector: (row: CommissionData) => row.line_type,
      cell: (row: CommissionData) => (
        <Card>
          <P type='3' variant='neutral'>
            {row.line_type}
          </P>
        </Card>
      ),
      minWidth: '120px',
      grow: 0.8,
    },
    {
      name: 'Forma de comisionar',
      selector: (row: CommissionData) => row.commission_type_name,
      cell: (row: CommissionData) => (
        <Card>
          <P type='3' variant='neutral'>
            {row.commission_type_name}
          </P>
        </Card>
      ),
      minWidth: '180px',
      grow: 1.2,
    },
    {
      name: '% Comisión',
      selector: (row: CommissionData) => row.amount,
      cell: (row: CommissionData) => (
        <Card>
          <P type='3' variant='neutral'>
            {row.amount}%
          </P>
        </Card>
      ),
      minWidth: '100px',
      grow: 0.6,
    },
  ];
}
